import React from "react";
import {PanTool} from "@mui/icons-material";
import {useKeycloak} from "@react-keycloak/web";
import {Link} from "react-router-dom";


const MustAuth = () => {

    const { keycloak } = useKeycloak();

    React.useEffect(() => {
        keycloak.login()
    }, [])
    return "";

   /* return <div className="content page-main-inner cadrant-full-page">
        <div className="content-message">
            <p className="code-error">Accès privé <span className="danger">403</span></p>
            <PanTool className="icon-error" />
            <p className="message-error">
                Vous devez vous connecter pour accéder à cette interface
            </p>

            {/!*<div className="log-sign-in">*!/}
            {/!*    <a href={"#"} onClick={() => keycloak.login()}>*!/}
            {/!*        Se connecter*!/}
            {/!*    </a>*!/}
            {/!*    &nbsp;/&nbsp;*!/}
            {/!*    <Link to={"/ui/register"}>*!/}
            {/!*        S'enregistrer*!/}
            {/!*    </Link>*!/}
            {/!*</div>*!/}

        </div>
    </div>*/
}

export default MustAuth
